import { Injectable, effect, inject } from '@angular/core';
import { DjangoService, Routes } from '@core/services/django.service';
import { EnvironmentService } from '@core/services/environment.service';
import { ModalService } from '@features/modal/services/modal.service';
import { NearestIncompleteInvoice } from '@generated/openapi/model/nearestIncompleteInvoice';
import { IncompleteInfoModalComponent } from '@shared/incomplete-info-modal/incomplete-info-modal.component';
import { createNotifier } from 'ngxtension/create-notifier';
import { derivedAsync } from 'ngxtension/derived-async';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class IncompleteTripCheckService {
    private djangoService = inject(DjangoService);
    private modalService = inject(ModalService);
    private environmentService = inject(EnvironmentService);
    // Notifier for manually refreshing the check
    private refreshNotifier = createNotifier();

    // Fetch nearest incomplete trip data
    nearestIncompleteTrip = derivedAsync(() => {
        this.refreshNotifier.listen();
        // Browser only: prerendered shells must not call the backend at build time.
        if (this.environmentService.isServer()) {
            return of(undefined);
        }
        return this.djangoService.drfGet<NearestIncompleteInvoice>(
            Routes.dashboard,
            'nearest_incomplete_trip'
        );
    });

    constructor() {
        // Automatically show modal when incomplete trip is detected
        effect(() => {
            const tripData = this.nearestIncompleteTrip();
            if (tripData?.id) {
                this.showIncompleteInfoModal();
            }
        });
    }

    // Show the incomplete info modal
    private showIncompleteInfoModal() {
        this.modalService.show(
            IncompleteInfoModalComponent,
            {
                invoiceId: this.nearestIncompleteTrip()?.id,
            },
            false,
            false
        );
    }

    // Manually refresh the incomplete trip check
    refresh() {
        this.refreshNotifier.notify();
    }
}
